import React, { useState } from 'react';
import { WifiIcon, CloudUploadIcon, CheckCircle2Icon, ClockIcon, RefreshCwIcon } from 'lucide-react';
export function SyncScreen() {
  const [isSyncing, setIsSyncing] = useState(false);
  const [synced, setSynced] = useState(false);
  const handleSync = () => {
    setIsSyncing(true);
    setTimeout(() => {
      setIsSyncing(false);
      setSynced(true);
    }, 2000);
  };
  return <div className="p-4 flex flex-col gap-6" data-id="element-249">
      {/* Status Card */}
      <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-250">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4" data-id="element-251">
          <WifiIcon className="w-8 h-8 text-green-600" data-id="element-252" />
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-1" data-id="element-253">En Línea</h2>
        <p className="text-gray-500" data-id="element-254">
          Conexión estable. Listo para sincronizar.
        </p>
      </div>

      {/* Pending Items */}
      <div data-id="element-255">
        <div className="flex justify-between items-end mb-4 px-1" data-id="element-256">
          <h3 className="text-lg font-bold text-gray-900" style={{
          color: '#134073'
        }} data-id="element-257">
            Recolecciones Pendientes
          </h3>
          <span className="bg-red-100 text-red-700 text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-258">
            {synced ? '0' : '2'}
          </span>
        </div>

        {!synced ? <div className="space-y-3" data-id="element-259">
            <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex items-center justify-between" data-id="element-260">
              <div data-id="element-261">
                <h4 className="font-bold text-gray-900" data-id="element-262">Emergencia</h4>
                <p className="text-sm text-gray-500" data-id="element-263">
                  Hoy, 10:45 AM • 45 prendas
                </p>
              </div>
              <ClockIcon className="w-6 h-6 text-orange-400" data-id="element-264" />
            </div>
            <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex items-center justify-between" data-id="element-265">
              <div data-id="element-266">
                <h4 className="font-bold text-gray-900" data-id="element-267">UCI</h4>
                <p className="text-sm text-gray-500" data-id="element-268">
                  Hoy, 09:15 AM • 28 prendas
                </p>
              </div>
              <ClockIcon className="w-6 h-6 text-orange-400" data-id="element-269" />
            </div>
          </div> : <div className="bg-green-50 border border-green-200 rounded-xl p-6 text-center" data-id="element-270">
            <CheckCircle2Icon className="w-12 h-12 text-green-500 mx-auto mb-3" data-id="element-271" />
            <p className="font-bold text-green-800" data-id="element-272">Todo está sincronizado</p>
            <p className="text-sm text-green-600 mt-1" data-id="element-273">
              No hay recolecciones pendientes de enviar.
            </p>
          </div>}
      </div>

      {/* Sync Action */}
      <div className="mt-4" data-id="element-274">
        <button onClick={handleSync} disabled={isSyncing || synced} className={`w-full h-14 rounded-xl flex items-center justify-center gap-2 text-lg font-bold shadow-md transition-all ${isSyncing || synced ? 'bg-gray-300 text-gray-500' : 'text-white active:scale-[0.98]'}`} style={!isSyncing && !synced ? {
        backgroundColor: '#3d99d2'
      } : {}} data-id="element-275">
          {isSyncing ? <>
              <RefreshCwIcon className="w-6 h-6 animate-spin" data-id="element-276" />
              Sincronizando...
            </> : <>
              <CloudUploadIcon className="w-6 h-6" data-id="element-277" />
              Enviar al Sistema
            </>}
        </button>
        <p className="text-center text-xs text-gray-400 mt-4" data-id="element-278">
          Última sincronización: {synced ? 'Justo ahora' : 'Hace 5 horas'}
        </p>
      </div>
    </div>;
}